class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    if (this.button) {
      this.button.addEventListener('click', this._onButtonClick.bind(this));
    }

    this.initialNextUrl = this.getAttribute('next-url');
    this.initialCurrentPage = parseInt(this.getAttribute('current-page'));
    
    this.nextUrl = this.initialNextUrl;
    this.currentPage = this.initialCurrentPage;
    this.totalPages = parseInt(this.getAttribute('total-pages'));
    this.loadMoreText = this.getAttribute('load-more-text');
    this.showLessText = this.getAttribute('show-less-text');
    this.isLoading = false;
  }

  async _onButtonClick() {
    if (this.isLoading) return;

    if (this.currentPage >= this.totalPages) {
      this._showLess();
      return;
    }

    this.isLoading = true;
    this.button.setAttribute('aria-busy', 'true');

    // Get the current section and product list
    const section = this.closest('.shopify-section');
    const productList = section ? section.querySelector('.product-list') : document.querySelector('.product-list');
    const sectionId = section ? section.id.replace('shopify-section-', '') : '';

    let fetchUrl = this.nextUrl;
    // Optimize by requesting only the section content if possible
    if (sectionId && fetchUrl && !fetchUrl.includes('section_id=')) {
      const url = new URL(fetchUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      fetchUrl = url.toString();
    }

    try {
      const response = await fetch(fetchUrl);
      if (!response.ok) throw new Error('Network response was not ok');
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find product list in fetched content
      let fetchedProductList = doc.querySelector('.product-list');
      
      if (!fetchedProductList && sectionId) {
        const fetchedSection = doc.getElementById(`shopify-section-${sectionId}`);
        if (fetchedSection) {
          fetchedProductList = fetchedSection.querySelector('.product-list');
        }
      }
      
      const newProducts = fetchedProductList ? Array.from(fetchedProductList.querySelectorAll(':scope > *')) : [];

      if (newProducts.length > 0 && productList) {
        newProducts.forEach((product, index) => {
          // Mark as ajax-loaded item for easy removal
          product.setAttribute('data-ajax-loaded', 'true');
          
          product.style.opacity = '0';
          product.style.transform = 'translateY(15px)';
          product.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
          
          productList.appendChild(product);
          
          requestAnimationFrame(() => {
            setTimeout(() => {
              product.style.opacity = '1';
              product.style.transform = 'translateY(0)';
            }, index * 50);
          });
        });

        // Update state
        this.currentPage++;
        
        // Find the next pagination link in the fetched HTML to update nextUrl
        const nextLoadMore = doc.querySelector('load-more');
        if (nextLoadMore) {
          this.nextUrl = nextLoadMore.getAttribute('next-url');
        } else {
          this.nextUrl = null;
        }

        if (this.currentPage >= this.totalPages) {
          const textSpan = this.button.querySelector('.load-more__button-content span');
          if (textSpan) textSpan.textContent = this.showLessText;
          this.setAttribute('data-all-loaded', 'true');
        }
      }
    } catch (error) {
      console.error('Failed to load more products:', error);
    } finally {
      this.isLoading = false;
      this.button.removeAttribute('aria-busy');
    }
  }

  _showLess() {
    // Reset the collection view without refreshing the page
    const section = this.closest('.shopify-section');
    const productList = section ? section.querySelector('.product-list') : document.querySelector('.product-list');
    
    if (productList) {
      const addedItems = productList.querySelectorAll('[data-ajax-loaded="true"]');
      addedItems.forEach(item => item.remove());
      
      // Scroll back to the results top
      const resultsElement = section ? section.querySelector('.collection__results') : productList;
      if (resultsElement) {
        resultsElement.scrollIntoView({ behavior: 'smooth' });
      }
    }

    // Reset state
    this.currentPage = this.initialCurrentPage;
    this.nextUrl = this.initialNextUrl;
    
    const textSpan = this.button.querySelector('.load-more__button-content span');
    if (textSpan) textSpan.textContent = this.loadMoreText;
    
    this.removeAttribute('data-all-loaded');
  }
}

if (!window.customElements.get('load-more')) {
  window.customElements.define('load-more', LoadMore);
}
